import firebase from "firebase";
import "firebase/firestore";

// firebase init goes here
var config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGE_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};

firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const currentUser = auth.currentUser;

// date issue fix according to firebase
const settings = {
  // timestampsInSnapshots: true
};
db.settings(settings);

// firebase collections
const usersCollection = db.collection("users");
const benchmarksCollection = db.collection("benchmarks");
const profilesCollection = db.collection("profiles");
const functionalityCollection = db.collection("functionality");
const functionalityBetaCollection = db.collection("functionalityBeta");
const archetypesCollection = db.collection("archetypes");
const keywordsCollection = db.collection("keywords");
const projectsCollection = db.collection("projects");
const exercisesCollection = db.collection("exercises");
const tilesCollection = db.collection("tiles");
const pictosCollection = db.collection("pictos");
const planesCollection = db.collection("planes");
const travelCollection = db.collection("travel");
const signsCollection = db.collection("signs");
const signsExCollection = db.collection("signsEx");
const groupsCollection = db.collection("groups");
const tilesExCollection = db.collection("tilesEx");
const tilesExCollectionExtended = db.collection("tilesExCollectionExtended");
const tilesFutureExCollection = db.collection("tilesFutureEx");
const tilesMultipleExCollection = db.collection("tilesMultipleEx");
const personaExCollection = db.collection("personaEx");
const groupsExCollection = db.collection("groupsEx");
const functionalityExCollection = db.collection("functionalityEx");
const archetypesExCollection = db.collection("archetypesEx");
const keywordsExCollection = db.collection("keywordsEx");
const tovExCollection = db.collection("tovEx");
const pictosExCollection = db.collection("pictosEx");
const exServiceNotesCollection = db.collection("serviceNotesEx");
const serviceExCollection = db.collection("serviceEx");
const serviceTagsCollection = db.collection("serviceTags");
const propositionExCollection = db.collection("propositionEx");
const messageExCollection = db.collection("messageEx");
const messageContentCollection = db.collection("messageContent");
const flyExCollection = db.collection("flyEx");
const swotExCollection = db.collection("swotEx");
const activateExCollection = db.collection("activeEx");
const activateStarExCollection = db.collection("activeStarEx");
const travelExCollection = db.collection("travelEx");
const architectureExCollection = db.collection("architectureEx");
const structureExCollection = db.collection("structureEx");
const trafficExCollection = db.collection("trafficEx");
const empathyExCollection = db.collection("empathyEx");
const problemExCollection = db.collection("problemEx");
const isinifExCollection = db.collection("isinifEx");
const blocksExCollection = db.collection("blocksEx");
const priorityExCollection = db.collection("priorityEx");
const stakeholderExCollection = db.collection("stakeholderEx");
const competitionExCollection = db.collection("competitionEx");
const deliverablesExCollection = db.collection("deliverablesEx");
const deliverablesAmbassadorsExCollection = db.collection(
  "deliverablesAmbassadorsEx"
);
const competitionDetailExCollection = db.collection(
  "competitionDetailExCollection"
);
const competitionMatrix1ExCollection = db.collection(
  "competitionMatrix1ExCollection"
);
const competitionMatrix2ExCollection = db.collection(
  "competitionMatrix2ExCollection"
);
const audienceExCollection = db.collection("audienceEx");
const successExCollection = db.collection("successEx");
const successPillarsExCollection = db.collection("successPillarsEx");
const challengePillarsExCollection = db.collection(
  "challengePillarsExCollection"
);
const attributesPt1ExCollection = db.collection("attributesPt1Ex");
const attributesPt2ExCollection = db.collection("attributesPt2Ex");
const brandArchitectureExCollection = db.collection(
  "brandArchitectureExCollection"
);

const internalDeliverableseExCollection = db.collection(
  "internalDeliverableseExCollection"
);
const fourCornersExCollection = db.collection("fourCornersEx");
const fourCornersContextExCollection = db.collection("fourCornersContextEx");
const fourCornersClientExCollection = db.collection("fourCornersClientEx");
const fourCornersCustomerExCollection = db.collection("fourCornersCustomerEx");
const fourCornersCompetitionExCollection = db.collection(
  "fourCornersCompetitonEx"
);
const competitionContentCollection = db.collection(
  "competitionContentCollection"
);

const timelineExCollection = db.collection("timelineEx");

const todayTomorrowExCollection = db.collection("todayTomorrowExCollection");

const timelineADEExCollection = db.collection("timelineADEExCollection");

const sayDoExCollection = db.collection("sayDoExCollection");

const sayDoThemeExCollection = db.collection("sayDoThemeExCollection");

const namingExCollection = db.collection("namingEx");

const ecoExCollection = db.collection("ecoEx");

const mappingExCollection = db.collection("mappingEx");

const cultureLanguageExCollection = db.collection("cultureLanguageEx");
const cultureBehaviourExCollection = db.collection("cultureBehaviourEx");
const cultureKnowledgeExCollection = db.collection("cultureKnowledgeEx");
const cultureDynamicsExCollection = db.collection("cultureDynamicsEx");
const audienceSystemExCollection = db.collection("audienceSystemExCollection");
const offerSystemExCollection = db.collection("offerSystemExCollection");
const offerSystemExCollectionCards = db.collection("offerSystemExCollectionCards");
const rollOutExCollection = db.collection("rollOutExCollection");
const tilesExCollectionSurvey = db.collection("tilesExCollectionSurvey");

const challengesSystemExCollection = db.collection(
  "challengesSystemExCollection"
);

const logicSystemExCollection = db.collection("logicSystemExCollection");

const museumExCollection = db.collection("museumEx");
const museumSummaryCollection = db.collection("museumSummaryEx");

export {
  db,
  auth,
  storage,
  currentUser,
  projectsCollection,
  exercisesCollection,
  benchmarksCollection,
  functionalityCollection,
  archetypesCollection,
  keywordsCollection,
  groupsCollection,
  profilesCollection,
  tilesCollection,
  pictosCollection,
  usersCollection,
  tilesExCollection,
  tilesFutureExCollection,
  tilesMultipleExCollection,
  tilesExCollectionExtended,
  personaExCollection,
  groupsExCollection,
  serviceExCollection,
  functionalityExCollection,
  deliverablesExCollection,
  deliverablesAmbassadorsExCollection,
  internalDeliverableseExCollection,
  archetypesExCollection,
  keywordsExCollection,
  tovExCollection,
  signsExCollection,
  signsCollection,
  pictosExCollection,
  exServiceNotesCollection,
  serviceTagsCollection,
  propositionExCollection,
  messageExCollection,
  messageContentCollection,
  planesCollection,
  flyExCollection,
  swotExCollection,
  activateExCollection,
  activateStarExCollection,
  travelExCollection,
  travelCollection,
  architectureExCollection,
  structureExCollection,
  trafficExCollection,
  empathyExCollection,
  problemExCollection,
  isinifExCollection,
  blocksExCollection,
  priorityExCollection,
  stakeholderExCollection,
  competitionExCollection,
  competitionDetailExCollection,
  audienceExCollection,
  successExCollection,
  successPillarsExCollection,
  challengePillarsExCollection,
  attributesPt1ExCollection,
  attributesPt2ExCollection,
  brandArchitectureExCollection,
  competitionMatrix1ExCollection,
  competitionMatrix2ExCollection,
  fourCornersExCollection,
  fourCornersContextExCollection,
  fourCornersClientExCollection,
  fourCornersCustomerExCollection,
  fourCornersCompetitionExCollection,
  competitionContentCollection,
  timelineExCollection,
  todayTomorrowExCollection,
  timelineADEExCollection,
  sayDoExCollection,
  sayDoThemeExCollection,
  namingExCollection,
  ecoExCollection,
  mappingExCollection,
  cultureLanguageExCollection,
  cultureBehaviourExCollection,
  cultureKnowledgeExCollection,
  cultureDynamicsExCollection,
  functionalityBetaCollection,
  audienceSystemExCollection,
  offerSystemExCollection,
  offerSystemExCollectionCards,
  rollOutExCollection,
  challengesSystemExCollection,
  logicSystemExCollection,
  museumExCollection,
  museumSummaryCollection,
  tilesExCollectionSurvey
};
